import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import type { LogoBlockProps, LogoSize } from "./types";

export default function PanelLogoSize() {
	const blockProps = useBlockPanelPropsContext() as LogoBlockProps;
	const value = blockProps.block.properties?.size || "medium";

	const handleUpdate = (size: LogoSize) => {
		blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
			...blockProps.block,
			properties: {
				...blockProps.block.properties,
				size,
			},
		});
	}

	return (
		<PanelInlineContent title="Taille">
			<ToggleGroup
				variant="default"
				type="single"
				className="bg-background border shadow"
				value={value}
				onValueChange={(value) => {
					if (
						value &&
						(value === "small" || value === "medium" || value === "large")
					) {
						handleUpdate(value as LogoSize);
					}
				}}
			>
				<ToggleGroupItem value="small" aria-label="Petite taille">
					<span className="text-xs font-medium">Petit</span>
				</ToggleGroupItem>
				<ToggleGroupItem value="medium" aria-label="Taille moyenne">
					<span className="text-xs font-medium">Moyen</span>
				</ToggleGroupItem>
				<ToggleGroupItem value="large" aria-label="Grande taille">
					<span className="text-xs font-medium">Grand</span>
				</ToggleGroupItem>
			</ToggleGroup>
		</PanelInlineContent>
	)
}
